import { getPublicConfig } from "@/shared/config/config"
import type { MicroFrontendUrl } from "@/shared/types/MicroFrontendUrl"
import { logger } from "@/shared/utils/add/logger/logger"
import type { IMicroFrontendApi } from "./iMicroFrontendApi"
import devMicrofrontendConfig from "./microFrontends.dev.json"
import prodMicrofrontendConfig from "./microFrontends.prod.json"

function getMicrofrontendConfig(): MicroFrontendUrl[] {
  const { environment } = getPublicConfig()

  switch (environment) {
    case "development":
    case "local":
      return devMicrofrontendConfig as MicroFrontendUrl[]
    case "production":
      return prodMicrofrontendConfig as MicroFrontendUrl[]
    default:
      logger.warn(`Unknown environment: ${environment as string}, falling back to development config`)
      return devMicrofrontendConfig as MicroFrontendUrl[]
  }
}

// eslint-disable-next-line @typescript-eslint/require-await
const getMicroFrontendUrls = async (): Promise<MicroFrontendUrl[]> => getMicrofrontendConfig()

const microFrontendApi = { getMicroFrontendUrls } as IMicroFrontendApi
export { microFrontendApi }
